import React, { useEffect, useState } from "react";
import {Button, Checkbox} from "antd";
import "./index.less";
import { LightningSearchTypeEnum } from "@/util/cosntants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";
import { updateIsRefresh, updateIsStartDownloadImage, updateSearchType } from "@/redux/actions/lightningAction";
import downloadIcon from "@/resource/images/png/lightning/download-icon.png";
import { LightningPlusIcon } from "@/resource/IconComponents";
import LightningFeedbackModal from "@/page/LightningComponent/components/FeedbackModal";
import { ReloadOutlined } from "@ant-design/icons";
import useInactivityWarning from "./useInactivityWarning";
interface IStrikeArrayModel{
    label: string;
    value: LightningSearchTypeEnum;
}

const StrikeArray = [
    {
        label: "First Strike",
        value: LightningSearchTypeEnum.FIRSTSTRIKE
    },
    {
        label: "Detected Strike",
        value: LightningSearchTypeEnum.DETECTED
    },
    {
        label: "Probability",
        value: LightningSearchTypeEnum.PROBABILITY
    },
    {
        label: "Risk Zone",
        // label: "All Clear",
        value: LightningSearchTypeEnum.ALLCLEAR
    }
];


const LightningInvokeStrike = () => {

    const searchType = useSelector((state: RootState) => state.lightningReducer.searchType);
    const searchResult = useSelector((state: RootState) => state.lightningReducer.searchResult);
    const isClickedSearchResultButton = useSelector((state: RootState) => state.lightningReducer.isClickedSearchResultButton);

    const dispatch = useDispatch();

    // 使用自定义 Hook
    // useInactivityWarning(isClickedSearchResultButton);
    useInactivityWarning({
        isClickedSearchResultButton, timeoutMs : 5 * 60 * 1000
    }); // 0.2分钟 = 12秒

    const [isFeedbackModalVisible, setIsFeedbackModalVisible] = useState(false);
    const [isDownloadImageVIsible, setIsDownloadImageVisible] = useState(false);

    const handleAddFeedback = () => {
        setIsFeedbackModalVisible(true);
    };

    const handleCloseFeedbackModal = () => {
        setIsFeedbackModalVisible(false);
    };

    const handleRefresh = () => {
        dispatch(updateIsRefresh(true));
    };

    useEffect(()=>{
        if(searchResult && searchResult.features && searchResult.features.length > 0){
            setIsDownloadImageVisible(true);
        }else{
            setIsDownloadImageVisible(false);
        }
    },[searchResult]);

    return (
        <div className="lightning-invoke-strike">

            <div className="lightning-invoke-strike__content">
                {
                    StrikeArray?.map((item,index)=>{
                        return(
                            <>
                                <div
                                    // className="lightning-invoke-strike__content__item"
                                    className={`lightning-invoke-strike__content__item ${searchType === item.value ? "strike-active" : ""}`}
                                    onClick={()=>{
                                        dispatch(updateSearchType(item.value));
                                        if(isClickedSearchResultButton === true){
                                            dispatch(updateIsRefresh(true));
                                        }
                                    }}
                                >
                                    <span>{item?.label}</span>
                                </div>
                            </>
                        );
                    })
                }
                <div className="refresh-div">
                    <Button
                        onClick={()=>{
                            handleRefresh();
                        }}
                        className="refresh-button"><ReloadOutlined />Refresh
                    </Button>
                </div>
            </div>
            <div className="lightning-feedback-download" >
                <div className="lightning-feedback"
                    onClick={()=>{
                        handleAddFeedback();
                    }}
                >
                    <LightningPlusIcon />
                    Add Feedback
                </div>
                {/* For Download */}
                <div className="lightning-invoke-strike__download">
                    <div>Download Image</div>
                    <div className={`${ isDownloadImageVIsible ? "img-div " : "img-div-disable"}`}
                        onClick={()=>{
                            if(!isDownloadImageVIsible){
                                return;
                            }
                            dispatch(updateIsStartDownloadImage(true));
                        }}
                    >
                        <img src={downloadIcon} />
                    </div>
                </div>
            </div>
            <LightningFeedbackModal
                visible={isFeedbackModalVisible}
                onClose={handleCloseFeedbackModal}
            />
        </div>
    );
};

export default LightningInvokeStrike;